import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getAllWorkingStatuses } from "~/modules/project/api/workingStatus/workingStatusApiDispatchers.ts";

const ENTITY_QUERY_KEY = "workingStatus";

export const ALL_WORKING_STATUSES_QUERY_KEY = [ENTITY_QUERY_KEY, "all"];

export const useAllWorkingStatuses = (enabled: boolean = true) => useQuery({
    queryKey: ALL_WORKING_STATUSES_QUERY_KEY,
    queryFn: () => getAllWorkingStatuses().then(getDataFromResponse),
    enabled
});